(function ($, Drupal, once) {
  Drupal.behaviors.productSliders = {
    attach: function (context, settings) {
      // Select all slider instances
      const sliders = once('product-slider-init', '.product-section .splide', context);

      sliders.forEach((sliderElement) => {
        const slideCount = sliderElement.querySelectorAll('.splide__slide').length;

        const splideSlider = new Splide(sliderElement, {
          // Desktop defaults (over 768px)
          type: slideCount > 3 ? 'loop' : 'slide',
          perPage: 3,
          fixedWidth: '362px',
          gap: '30px',
          trimSpace: false,
          arrows: slideCount > 3,
          drag: slideCount > 3,
          pagination: false,
          breakpoints: {
            // Mobile/Tablet: screens smaller than 768px (md)
            1200: {
              fixedWidth: '290px',
              // Enable slider features if more than 1 slide exists
              type: slideCount > 2 ? 'loop' : 'slide',
              arrows: slideCount > 3,
              gap: '25px',
              pagination: true
            },
            1024: {
              fixedWidth: '100%',
              perPage: 1,
              // Enable slider features if more than 1 slide exists
              type: slideCount > 1 ? 'loop' : 'slide',
              drag: slideCount > 1,
              gap: '20px',
              pagination: true,
              arrows: false
            },
            // Extra small mobile: screens smaller than 450px (xsm)
            570: {
              fixedWidth: '100%',
              gap: '10px'
            }
          },
        });

        // CSS class logic for centering static elements
        if (slideCount <= 2) {
          sliderElement.classList.add('is-static-desktop');
        }

        if (slideCount <= 1) {
          sliderElement.classList.add('is-static-mobile');
        }

        splideSlider.mount();
      });

      $('.reset-button').click(function(e) {
        e.preventDefault();
        $('.form-actions input[name="reset"]').trigger('click');
      });
    }
  };
})(jQuery, Drupal, once);